import axiosInstance from "./axiosInstance";

const featureService = {
    /** Overview tab only – users, proposals, gender stats, premium count. Call on dashboard load. */
    fetchOverview: async () => {
        try {
            const response = await axiosInstance.get('admin/users/dashboard');
            return response.data;
        } catch (error) {
            throw error.response?.data ?? error;
        }
    },
    /** Subscriptions tab – payment analytics + monthly stats. Call when user opens Subscriptions tab. */
    fetchDashboardSubscriptions: async () => {
        try {
            const response = await axiosInstance.get('admin/users/dashboard/subscriptions');
            return response.data;
        } catch (error) {
            throw error.response?.data ?? error;
        }
    },
    /** Users tab – user analytics + monthly user stats. Call when user opens Users tab. */
    fetchDashboardUsers: async () => {
        try {
            const response = await axiosInstance.get('admin/users/dashboard/users');
            return response.data;
        } catch (error) {
            throw error.response?.data ?? error;
        }
    },
    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('admin/users/dashboard');
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchPaymentStats: async (params = {}) => {
        try {
            const query = new URLSearchParams();
            if (params.date) query.set('date', params.date);
            if (params.month != null && params.month !== '') query.set('month', params.month);
            if (params.year != null && params.year !== '') query.set('year', params.year);
            if (params.currency) query.set('currency', params.currency);
            if (params.location) query.set('location', params.location);
            const url = query.toString()
                ? `admin/users/payment-stats?${query.toString()}`
                : 'admin/users/payment-stats';
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            throw error?.response?.data ?? error;
        }
    },
    fetchPaymentStatsByDay: async (month, year, currency = null) => {
        try {
            const query = new URLSearchParams({ month, year });
            if (currency) query.set('currency', currency);
            const response = await axiosInstance.get(`admin/users/payment-stats/by-day?${query.toString()}`);
            return response.data;
        } catch (error) {
            throw error?.response?.data ?? error;
        }
    },
}

export default featureService
